import { Button, ButtonGroup, H2 } from "@datapay-by-datacom/design-system";
import s from "./ThreadCreate.module.css";
import { useCreateThread } from "../hooks/useCreateThread";
import { useWorkspace } from "../../workspace";
import { useAuthenticated } from "../../authn";
import { useUserOrgs, useUserOrgPreferences } from "../../org/hooks";
import { AsyncResult } from "../../shared";
import {
  IoWalletOutline,
  IoSwapHorizontalOutline,
  IoSettingsOutline,
  IoHelpCircleOutline,
} from "react-icons/io5";
import { getLogoUrl } from "../../brand-config";
import { useMemo } from "react";

export function ThreadCreate() {
  const workspace = useWorkspace();
  const { createThread } = useCreateThread(workspace.workspace_id);
  const { userId } = useAuthenticated();
  const userOrgs = useUserOrgs(userId);
  const { preferences } = useUserOrgPreferences();
  const logoUrl = getLogoUrl();

  // Use preferences if available, otherwise fall back to all user orgs
  const defaultKnowledgeOrgs = useMemo(() => {
    return preferences.length > 0
      ? preferences
      : (userOrgs.data || []).map((org) => ({
          id: org.id,
          category: org.category,
        }));
  }, [preferences, userOrgs.data]);

  return (
    <div className={s.threadCreateContainer}>
      <div className={s.logoContainer}>
        {!logoUrl && (
          <img
            src="datapay-logo.svg"
            alt="DataPay Logo"
            className={s.pulsingLogo}
          />
        )}
      </div>
      <H2 style={{ textTransform: "none" }}>What do you want to do today?</H2>
      <AsyncResult query={userOrgs}>
        {(_userOrgs) => (
          <div
            style={{ display: "flex", flexDirection: "column", gap: "15px" }}
          >
            <ButtonGroup>
              <Button
                variant="secondary"
                size="large"
                onPress={() => createThread("", defaultKnowledgeOrgs)}
              >
                <IoWalletOutline /> Solve a payroll problem
              </Button>

              <Button
                style={{ display: "none" }}
                variant="secondary"
                size="large"
                isDisabled
                onPress={() => createThread("Migrate a customer", [])}
              >
                <IoSwapHorizontalOutline /> Migrate a customer
              </Button>
            </ButtonGroup>

            <ButtonGroup>
              <Button
                style={{ display: "none" }}
                variant="secondary"
                size="large"
                isDisabled
                onPress={() => createThread("Maintain a customer", [])}
              >
                <IoSettingsOutline /> Maintain a customer
              </Button>

              <Button
                style={{ display: "none" }}
                variant="secondary"
                size="large"
                isDisabled
                onPress={() => createThread("Tell me what I should do", [])}
              >
                <IoHelpCircleOutline /> You tell me
              </Button>
            </ButtonGroup>
          </div>
        )}
      </AsyncResult>
    </div>
  );
}
